/** Un séjour est libre seulement si chaque jour de la carte est disponible. */
export const isStayFullyAvailable = (days: Array<{ status: string }>): boolean =>
  days.length > 0 && days.every((day) => day.status === "available");
